/**
 * Pages de donoor.org disponibles dans les 6 langues (/en, /de, /es, /it, /nl).
 *
 * Décision Karim 2026-10-12 : TOUT le site est traduit, sauf le blog (les
 * articles restent en français pour le moment). Les pages marketing / SEO
 * portent leurs textes avec elles (bloc `<i18n src>` → i18n/pages/…), chargés
 * seulement sur la page concernée.
 *
 * Les motifs portent sur le chemin du FICHIER dans app/pages (sans « .vue »).
 * Le hook `pages:extend` de nuxt.config.ts pose `meta.i18n = false` sur les
 * pages EXCLUES : @nuxtjs/i18n (customRoutes: "meta") ne leur crée alors
 * aucune route traduite, et leur nom de route reste inchangé.
 */
export const PAGES_FRANCAIS_SEUL: readonly RegExp[] = [
  /^blog(\/|$)/,
];

export function estPageTraduite(cheminFichier: string): boolean {
  return !PAGES_FRANCAIS_SEUL.some((motif) => motif.test(cheminFichier));
}
